import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './privacyPolicy.scss';

class PrivacyPolicy extends React.Component {
  render() {
    return (
      <div style={{ marginRight: '20px' }}>
        <ol>
         <li>
            Administratorem PORTALU E-USŁUG E-SPDP jest Firma GIAP Sp. z o.o. (ul. Pasaż Ursynowski 1/126, 02-784 Warszawa, NIP: 521-370-98-19, KRS: 581378, REGON: 362764079).
          </li>
         <li>
            Administrator PORTALU E-USŁUG E-SPDP przywiązuje szczególną wagę do poszanowania prywatności użytkowników korzystających z serwisu.
          </li>
         <li>
            Dane osobowe oznaczają informacje pozwalające na zidentyfikowanie osoby fizycznej lub podmiotu. Przetwarzanie danych to każda operacja dotycząca ich wykorzystania taka jak: zbieranie, przeglądanie, utrwalanie, porządkowanie, przechowywaniem, modyfikowanie, udostępnianie czy usuwanie.
          </li>
         <li>
            Administrator PORTALU E-USŁUG E-SPDP przetwarza dane osobowe w celach realizacji zadań publicznych. Zależnie od zadania, mogą występować różne podstawy prawne przetwarzania, zbierania i wykorzystywania danych osobowych.
          </li>
         <li>
            Osoby fizyczne i podmioty publiczne odwiedzające PORTAL E-USŁUG E-SPDP  posiadają kontrolę nad przekazywanymi danymi osobowymi. Portal zbiera dane w zakresie minimalnym koniecznym wyłącznie w celu obsłużenia sprawy.
          </li>
         <li>
            W celu korzystania z PORTALU E-USŁUG E-SPDP możemy wykorzystywać pliki Cookies (pot. ciasteczka), które są małymi plikami zapisywanymi na urządzeniu dostępowym używanym do przeglądania strony. Pozwalają nam one na personalizowanie sesji użytkownika w serwisie oraz przechowują między innymi informacje, takie jak: adres IP, dane sesji użytkownika, zapamiętane preferencje i ustawienia, datę ostatnich odwiedzin.
          </li>
         <li>
            PORTAL E-USŁUG E-SPDP korzysta z plików Cookies również w celu zbierania statystyk i sposobu zachowania użytkownika na poszczególnych podstronach, monitorowania ruchu w poszczególnych usługach, integracji z aplikacjami trzecimi, takimi jak: Węzeł Krajowy, ePUAP, KIR. W związku z powyższym na stronie mogą być wykorzystywanie pliki Cookies zewnętrznych dostawców wymienionych powyżej.
          </li>
        
         <li>
            Użytkownik może w każdej chwili wyświetlić, zablokować, bądź zezwolić na użytkowanie plików Cookies, jednakże ich brak może spowodować błędne działanie serwisu lub ograniczyć możliwości korzystania z niektórych oferowanych funkcji.
          </li>
         <li>
            W celach statystycznych, diagnozowania problemów, analizy naruszeń i incydentów oraz zgodnie z aktualnymi przepisami prawa PORTAL E-USŁUG E-SPDP zbiera i przetwarza adresy IP użytkowników odwiedzających stronę oraz inne dane wysyłane przez przeglądarkę internetową odwiedzającego. Na podstawie tych danych można określić rodzaj urządzenia dostępowego, rozdzielczość, model przeglądarki czy orientacyjne informacje o regionie z jakiego nastąpiło połączenie. Dane te nie są ujawniane osobom trzecim z wyłączeniem organów ścigania w przypadku prowadzonych postępowań i wykroczeń.
          </li>
         <li>
            Dane osobowe podawane w formularzu są traktowane jako poufne i nie są widoczne dla osób nieuprawnionych.
          </li>
         <li>
            Dane zbierane, mogą być przetwarzane w sposób zautomatyzowany, ale nie są poddawane profilowaniu. Przetwarzane dane zbierane są w oparciu o wyrażoną zgodę użytkownika końcowego akceptującego niniejszą politykę prywatności.
          </li>
         <li>
            Przetwarzanie danych osobowych wynika z wyrażonej zgody oraz obowiązków wynikających z aktualnie obowiązujących przepisów prawa.
          </li>
         <li>
            Dane osobowe za pośrednictwem PORTALU E-USŁUG E-SPDP mogą być przekazywane właściwemu urzędowi ze względu na realizację usług dostępnych na portalu.
          </li>
         <li>
            Dane osobowe nie są przekazywane do państw trzecich lub organizacji międzynarodowych.
          </li>
         <li>
            Każda osoba, której dane dotyczą ma prawo dostępu do danych, ich sprostowania, usunięcia lub ograniczenia przetwarzania, prawo sprzeciwu, prawo wniesienia skargi do organu nadzorczego.
          </li>
         <li>
            Kontakt z osobą nadzorująca przetwarzanie danych osobowych jest możliwy drogą elektroniczną pod adresem e-mail: epsdp@giap.pl
          </li>
         <li>
            Dane osobowe mogą być udostępnione podmiotom upoważnionym na podstawie właściwych przepisów prawa (np. organom ścigania).
          </li>
         <li>
            Usunięcie danych osobowych może nastąpić na skutek cofnięcia zgody bądź wniesienia prawnie dopuszczalnego sprzeciwu na przetwarzanie danych osobowych.
          </li>
         <li>
            Każda osoba fizyczna ma prawo wniesienia skargi do organu nadzorczego - Prezesa Ochrony Danych Osobowych, zajmującego się ochroną danych osobowych jeśli uzna, że jej dane osobowe są przetwarzane z naruszeniem przepisów prawa.
          </li>
        </ol>

        <p>
          Niniejsza polityka będzie aktualizowana zgodnie z potrzebami i zmianami.
          <br/><br/>
          Ostatnia aktualizacja: 15.01.2024 r.
        </p>
      </div>
    );
  }

};

export default withStyles(s)(PrivacyPolicy);



// WEBPACK FOOTER //
// src/components/utils/privacyPolicy/privacyPolicy.js